import { Modal, ModalContent, ModalOverlay, ModalHeader, ModalBody, Box, ModalFooter, HStack, Button, Text, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'

interface Props {
    onClose: () => void,
    isOpen: boolean,
    id: string,

}

const SendMessage = ({ onClose, isOpen, id }: Props) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const toast = useToast()

    const onSendMessage = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            toast({
                id: "messageSent",
                title: `Mensagem Enviada`,
                duration: 4000,
                position: "bottom",
                status: "success"
            })
            onClose();
        }, 2500)
    }

    return (
        <Modal onClose={isLoading ? () => {} : onClose} size="md" isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Envio de Mensagem</ModalHeader>
                <ModalBody>
                    <Box w="full" h="full" maxH="360px" overflowY="auto">
                        <Text fontSize="md">Confirme o envio de mensagem.</Text>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button disabled={isLoading} variant="ghost" onClick={onClose}>Fechar</Button>
                        <Button isLoading={isLoading} disabled={isLoading} colorScheme="green" onClick={onSendMessage}>Enviar</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default SendMessage